import { fetchQuotesHistoryData } from '@fe-common-ui/TrendChart';
import { fetchQuotesBySymbolsKeys } from '@fe-news/components/Aside/News24h/hooks/use-fetch-news24h';
import {
  SortType,
  fetchConceptStocksRanking
} from '@fe-news/components/IndexMobileWrapper/ConceptStocksRanking/use-fetch-concept-stocks-ranking';
import { fetchHotStocksData } from '@fe-news/components/IndexMobileWrapper/HotStocks/use-fetch-hot-stocks';
import { fetchMarketFocus } from '@fe-news/components/IndexMobileWrapper/MarketFocus/use-fetch-market-focus';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const quotesBySymbolsKeys = (symbols: string[]) => ({
  queryKey: symbols as [string],
  queryFn: () => fetchQuotesBySymbolsKeys(symbols)
});

const quoteBySymbol = (symbol: string) => ({
  queryKey: [symbol] as [string],
  queryFn: () => fetchQuotesHistoryData(symbol)
});

const quoteByMarketFocus = (type: string) => ({
  queryKey: [type] as [string],
  queryFn: () => fetchMarketFocus(type)
});

const QuotesByType = ({ type, limit, column }: { type: string; limit: number; column?: string }) => ({
  queryKey: [type, limit, column] as [string, number, string],
  queryFn: () =>
    fetchHotStocksData({
      type,
      limit,
      column
    })
});

const QuotesByConceptStocksRanking = ({
  period,
  sort,
  country,
  theme
}: {
  period: number;
  sort: SortType;
  country: string;
  theme: number;
}) => ({
  queryKey: [period, sort, country, theme] as [number, string, string, number],
  queryFn: () =>
    fetchConceptStocksRanking({
      period,
      sort,
      country,
      theme
    })
});

const quotes = createQueryKeys('quotes', {
  quotesBySymbolsKeys,
  quoteBySymbol,
  quoteByMarketFocus,
  QuotesByType,
  QuotesByConceptStocksRanking
});

export default quotes;
